import { render, staticRenderFns } from "./BillingReportDetailsView.vue?vue&type=template&id=515a5519&scoped=true"
import script from "./BillingReportDetailsView.vue?vue&type=script&lang=js"
export * from "./BillingReportDetailsView.vue?vue&type=script&lang=js"
import style0 from "./BillingReportDetailsView.vue?vue&type=style&index=0&id=515a5519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a5519",
  null
  
)

export default component.exports